// removed by extract-text-webpack-plugin
module.exports = {"colorPrimaryOrange":"#e16e46","colorWhite":"#ffffff","oldColorViolet3":"#C6B1D7","colorBackground":"rgb(245, 244, 243)","colorSecondaryRagRed":"#d2222d","colorSecondaryRagGreen":"#238823","colorSecondaryRagAmber":"#ffbf00","repositoryList":"appuser-upload-result-screen__repositoryList____1emn0","selected":"appuser-upload-result-screen__selected____9_oat","errorText":"appuser-upload-result-screen__errorText____m_9Gp","warningText":"appuser-upload-result-screen__warningText____1EO4K","okText":"appuser-upload-result-screen__okText____1L3Wt"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/screens/appuser-upload-screen/appuser-upload-result-screen.css
// module id = 483
// module chunks = 0